/* unplugin-vue-components disabled */import { render } from "./DeviceNumber.vue?vue&type=template&id=94b9f316&scoped=true"
import script from "./DeviceNumber.vue?vue&type=script&lang=js"
export * from "./DeviceNumber.vue?vue&type=script&lang=js"

import "./DeviceNumber.vue?vue&type=style&index=0&id=94b9f316&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b9f316"]])

export default __exports__